import { render, staticRenderFns } from "./SurgEdit.vue?vue&type=template&id=3219b50e"
import script from "./SurgEdit.vue?vue&type=script&lang=js"
export * from "./SurgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports